import { render, staticRenderFns } from "./UserRevocation.vue?vue&type=template&id=33ccd5cd&"
import script from "./UserRevocation.vue?vue&type=script&lang=js&"
export * from "./UserRevocation.vue?vue&type=script&lang=js&"
import style0 from "./UserRevocation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports